var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header-brand-tagline", attrs: { "aria-hidden": "true" } },
    [
      _c("span", { staticClass: "header-brand-tagline__line" }, [
        _vm._v(_vm._s(_vm.$t("header_brand_tagline_line1"))),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "header-brand-tagline__line" }, [
        _vm._v(_vm._s(_vm.$t("header_brand_tagline_line2"))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }